import { useLeaderboard } from './use-leaderboard';
import { getApproacherPosition } from '../utils/stats-calculations';

export function useApproacherRanking(approacherId: string | undefined): {
  position: number;
  total: number;
} {
  const { data } = useLeaderboard('total');
  if (!data || !approacherId) return { position: 0, total: 0 };
  return {
    position: getApproacherPosition(data, approacherId),
    total: data.length,
  };
}
